import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postsApi } from "../../../../../utils";
import ConfirmShareProjectPopup from "./ConfirmShareProjectPopup";
import useShareTypes from "../../../../../hooks/useShareTypes"
import { ObjectTypeEnum } from "../../../../../models/ObjectTypeEnum";
import { TargetObjectIdEnum } from "../../../../../models/TargetObjectIdEnum";
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";

const DeleteSharePostPopup = ({ setBeenSharedBefore, setShowPopup, close, dataPost, changePosts, getSelectedList }) => {
    const dispatch = useDispatch();
    const texts = useSelector(state => state.translate.texts);
    const selectedList = useShareTypes()

    useEffect(() => {
        if (dataPost) {
            const shareType = ObjectTypeEnum[dataPost?.shares[0]?.targetObjectType];
            if (shareType) {
                let title = texts.removePostConfirmTilte;
                let text = `${texts.RemovePostConfirm} ${selectedList()[shareType]} ?`;
                if (dataPost.shares[0].targetObjectId === TargetObjectIdEnum.External) {
                    title = texts.cancelExternalLinkConfirmTitle;
                    text = texts.cancelExternalLinkConfirm;
                }
                setShowPopup(<ConfirmShareProjectPopup type="Warn" close={() => setShowPopup(false)} confirmFunc={removePost} title={title} text={text} />)
            }
        }
    }, [dataPost])

    function removePost() {
        if (dataPost?.id) {
            postsApi.postsDeleteIdPost(dataPost.id, (error, resdata, response) => {
                if (error) {
                    if (error.status == 403) {
                        setShowPopup(<ConfirmShareProjectPopup 
                            type="Warn" 
                            close={() => setShowPopup(false)} 
                            title={texts.removePostConfirmTilte} 
                            text={`${texts.onlyYourStudentsPostsCanBeRemoved} ${texts.requestForwardedForProcessing}`} />)
                    }
                    else {
                        dispatch(throwApiError({ userMessage: texts.deletePostError, error: error, statusCode: response?.statusCode, message: "delete" + error.message, level: 2, component: "curriculum-actions", line: 17 }))
                    }
                }
                else {
                    if (getSelectedList && Object.keys(getSelectedList()).length == Object.keys(selectedList()).length - 1) {
                        setBeenSharedBefore(false)
                    }
                    let text = texts.successRemovePost;
                    if (dataPost.shares[0].targetObjectId === TargetObjectIdEnum.External) {
                        text = texts.cancelExternalLinkSuccess;
                    }
                    setShowPopup(<ConfirmShareProjectPopup changePosts={() => changePosts && changePosts()} close={() => close()} text={text} type={"successRemovePost"} />)
                }
            })
        }
    }

    return (
        <></>
    )
}

export default DeleteSharePostPopup;